import React from 'react';
import './InputComponent.scss';
import InputProps from '../../@types/Input.type';
import { useDispatch } from 'react-redux';

const InputComponent: React.FC<InputProps> = ({
  labelName,
  handleChange,
  validity,
  disabled,
}) => {
  const dispatch = useDispatch();
  // When the disabled is true, the input field should be disabled
  if (disabled) {
    return (
      <auro-input
        required
        noValidate
        bordered
        onInput={(e: React.ChangeEvent<HTMLInputElement>) =>
          dispatch(handleChange(e?.target?.value))
        }
        disabled
        data-testid={`input-${labelName}`}
      >
        <span slot="label">{labelName}</span>
      </auro-input>
    );
  }

  // When the input component is not disabled
  return (
    <auro-input
      // If validity is true then don't show the validation message else show the message
      error={validity ? undefined : 'Please enter a value'}
      required
      noValidate
      bordered
      onInput={(e: React.ChangeEvent<HTMLInputElement>) =>
        dispatch(handleChange(e?.target?.value))
      }
      data-testid={`input-${labelName}`}
    >
      <span slot="label">{labelName}</span>
    </auro-input>
  );
};

export default InputComponent;
